import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    container: {
      borderBottom: `1px solid ${theme.palette.secondary.light}`,
    },
    containerScroll: {
      '& .MuiTabs-scroller': {},
    },
    el: {
      fontSize: 16,
      lineHeight: '19px',
      textTransform: 'initial',
      fontWeight: 400,
      padding: '6px 0',
      marginLeft: 20,
      marginRight: 20,
      '&:first-child': {
        marginLeft: 0,
      },
    },
    elAutoWidth: {
      minWidth: 'initial',
    },
  }
})
